
import { defineComponent } from "vue";
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import ToolTip from "@/components/common/ToolTip.vue";
import messages from "@/config/messages";
import common from "@/config/common";
import routesPath from "@/config/routesPath";
import * as apiClient from "@/apiclient/";
import TokenService from "@/services/tokenService";
import { mapMutations } from "vuex";

export default defineComponent({
  name: "EditEmailView",
  components: {
    ToolTip,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      user: {
        emailAddress: "",
      },
      verificationTxt: "",
      isFormInvalid: false,
      validationMsg: "",
      isSubmitDisabled: false,
      messages,
      searchParticantToken: "",
    };
  },
  validations() {
    return {
      user: {
        emailAddress: { required, email },
      },
    };
  },
  mounted() {
    this.verificationTxt =
      this.$route.query.action === "register" ? "For Verification" : "";

    this.searchParticantToken = TokenService.getToken("SearchParticantToken")!;
    if (this.searchParticantToken?.length == 0) {
      this.$router.push({
        path: routesPath.base,
      });
    }
  },
  computed: {
    loginData() {
      const storedData = sessionStorage.getItem(
        common.storageVariables.loginData
      );
      return storedData ? JSON.parse(storedData) : null;
    },
  },
  methods: {
    ...mapMutations(["setMaskedEmailAddress"]),
    hideErrors(field: string): void {
      this.v$.user[field].$touch();
      this.isFormInvalid = false;
    },
    buttonDesign(): string {
      const buttonStatus = this.v$.user.emailAddress.$invalid;
      return buttonStatus == true ? "btn-secondary" : "btn-primary";
    },
    async verifyEmail(): Promise<void> {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }
      this.isSubmitDisabled = true;
      const params = {
        emailAddress: this.user.emailAddress,
      };
      const result = await apiClient
        .searchParticipantController()
        .postApiSearchparticipantEmailVerification(params, {
          headers: {
            Authorization: "Bearer " + this.searchParticantToken,
            "Content-Type": "application/json",
          },
        });

      this.isSubmitDisabled = false;
      if (!result || result.error) {
        this.isFormInvalid = true;
        if (result.error) {
          this.validationMsg = result.error + messages.errorMsg;
        }
        return;
      }
      sessionStorage.setItem(common.storageVariables.otpTimer, common.otpTimer);
      this.setMaskedEmailAddress(this.maskEmail(this.user.emailAddress));

      this.isFormInvalid = false;
      this.$router.push({
        name: routesPath.participantOTP,
      });
    },
    maskEmail(email: string) {
      const lengthToShow = 7;
      const maskedPart = "*".repeat(email.length - lengthToShow - 2);
      const visiblePart = email.slice(-lengthToShow);
      const emailStartPart = email.slice(0, 2);
      return emailStartPart + maskedPart + visiblePart;
    },
  },
});
